module.exports = __webpack_public_path__ + "img/339.e17896ae.jpg";